<template>
  <div class="box">
    <div class="main">
      <img
        class="yunImg"
        src="../../assets/img/record/yun.png"
        alt=""
        srcset=""
      />
      <div class="text">上传成功~</div>
      <div class="data" v-if="type==1">
        <div>
          <span class="dataSum">165</span>
          <span class="dataName">身高cm</span>
        </div>
        <span class="line"></span>
        <div>
          <span class="dataSum">60</span>
          <span class="dataName">体重kg</span>
        </div>
        <span class="line"></span>
        <div>
          <span class="dataSum">29</span>
          <span class="dataName">体质指数kg/m²</span>
        </div>
      </div>
      <div class="data" v-if="type==2">
        <div>
          <span class="dataSum">118</span>
          <span class="dataName">收缩压mmHg</span>
        </div>
        <span class="line"></span>
        <div>
          <span class="dataSum">90</span>
          <span class="dataName">舒张压mmHg</span>
        </div>
        <span class="line"></span>
        <div>
          <span class="dataSum">78</span>
          <span class="dataName">心率 次/分钟</span>
        </div>
      </div>
      <div class="data" v-if="type==3">
        <div>
          <span class="dataSum">37.5</span>
          <span class="dataName">体温℃</span>
        </div>
      </div>
      <div class="data" v-if="type==4">
        <div>
          <span class="dataSum">5.5</span>
          <span class="dataName">空腹mmol/L</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="state" v-if="type == 1">
        体质指数：<span class="blueSpan">正常</span>
      </div>
      <div class="state" v-if="type == 2">
        血压：<span class="blueSpan">正常</span>
      </div>
      <div class="state" v-if="type == 3">
        体温：<span class="blueSpan">正常</span>
      </div>
      <div class="state" v-if="type == 4">
        血糖：<span class="blueSpan">正常</span>
      </div>
      <div class="advice">
        <div class="top">饮食建议：</div>
        <div class="bottom">
          需要改善的危险因素有：定期监测，需控制体重，合理饮食，控制膳食总能量，少吃零食、甜食和少喝饮料
        </div>
        <div class="top">运动建议：</div>
        <div class="bottom">
          需要改善的危险因素有：定期监测，需控制体重，合理饮食，控制膳食总能量，少吃零食、甜食和少喝饮料
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "upload",
  components: {},
  data () {
    return {
      type: 1,
      id: 0
    };
  },
  beforeCreate () {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#F8F8F8;");
  },
  created () {
    // this.type = this.$route.query.type;
    this.id = this.$route.query.id;
  },
  mounted () {},
  methods: {}
};
</script>

<style scoped lang="less">
.box {
  padding-top: 16px;
}
.main {
  width: 718px;
  height: 444px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .yunImg {
    width: 204px;
    height: 130px;
    margin-top: 56px;
  }
  .text {
    font-size: 36px;
    font-weight: bold;
    color: #3e3e3e;
    margin-top: 32px;
  }
  .data {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 56px;
    div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      .dataSum {
        font-size: 40px;
        font-weight: bold;
        color: #357dfa;
      }
      .dataName {
        font-size: 24px;
        font-weight: 400;
        color: #868686;
        margin-top: 16px;
      }
    }
    .line {
      width: 0px;
      height: 32px;
      opacity: 0.3;
      border: 2px solid #d0d6e6;
    }
  }
}
.content {
  width: 718px;
  min-height: 600px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  margin: 0 auto;
  margin-top: 16px;
}
.state {
  font-size: 32px;
  font-weight: bold;
  color: #3e3e3e;
  padding: 48px 0px 32px 32px;
  .blueSpan {
    color: #357dfa;
    font-weight: bold;
  }
  .orangeSpan {
    color: #ffaf46;
    font-weight: bold;
  }
  .redSpan {
    color: #ff5266;
    font-weight: bold;
  }
}
.advice {
  font-size: 28px;
  font-weight: 400;
  color: #3e3e3e;
  padding: 0 32px;
  line-height: 48px;
  .top {
    font-weight: 600;
  }
  .bottom {
    text-indent: 64px;
    padding-bottom: 20px;
  }
}
</style>
